import React, { useState, useEffect, useRef } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import { EmailMaskedTextField } from '../../../components/Inputs/TextFields/MaskedTextFields/EmailMaskedTextField/EmailMaskedTextField';
import LoadingIndicator from '../../../components/Global/loading-indicator/loading-indicator';
import { EmailForm } from '../../../api/forms';
import { useMutation } from '@tanstack/react-query';

function EmailFormModal({ form, setForm }) {
  const [emailStatus, setEmailStatus] = useState('');
  const [email, setEmail] = useState();

  const executeMutate = useMutation({
    mutationFn: async () =>
      await EmailForm({
        FormFileName: form?.FormFileName,
        FormName: form?.FormName,
        EmailAddress: email,
      })(),
  });

  const emailFormOrderCall = () => {
    setEmailStatus('loading');

    executeMutate.mutate(
      {},
      {
        onError: () => {
          setTimeout(() => setEmailStatus('failure'), 1000);
        },
        onSuccess: (data) => {
          let parsed = JSON.parse(data);
          if (parsed == false) {
            throw new Error('Failed to Submit form');
          }
          setEmailStatus('success');
        },
      }
    );
  };

  const exit = () => {
    setEmail();
    setEmailStatus();
    setForm();
  };

  useEffect(() => {}, [emailStatus, form]);
  useEffect(() => {
    if (email) {
      emailFormOrderCall();
    }
  }, [email]);

  const getInnerMarkup = () => {
    if (email) {
      return <EmailSubmission status={emailStatus} retry={emailFormOrderCall} exit={exit} />;
    }
    return <EmailInput setEmail={setEmail} exit={exit} form={form} />;
  };

  if (form) {
    return (
      <Dialog
        open={true}
        onClose={() => {
          exit();
        }}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>
          Email Form
          <IconButton
            onClick={() => {
              exit();
            }}
            style={{ position: 'absolute', right: 8, top: 8 }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        {getInnerMarkup()}
      </Dialog>
    );
  }
  return null;
}

function EmailInput({ setEmail, exit, form }) {
  const textRef = useRef();
  const [validEmail, setValidEmail] = useState(false);
  const [errorText, setErrorText] = useState('');

  const setValidEmailCallback = (val) => {
    setValidEmail(val);
    if (val) {
      setErrorText('');
    } else {
      setErrorText('Invalid Email Address');
    }
  };
  return (
    <>
      <DialogContent id="email-form-modal-body">
        <div>
          <h6>
            <b>Form:</b> {form.FormName}
          </h6>
        </div>
        <EmailMaskedTextField
          margin="dense"
          variant="outlined"
          inputRef={textRef}
          validCallback={setValidEmailCallback}
          fullWidth
          errorText={errorText}
        />
      </DialogContent>
      <DialogActions>
        <button
          disabled={!validEmail}
          className="btn btn-success"
          onClick={() => {
            setEmail(textRef.current.inputElement.value);
          }}
        >
          Email Form
        </button>
        <button
          className="btn btn-danger"
          onClick={() => {
            exit();
          }}
        >
          Cancel
        </button>
      </DialogActions>
    </>
  );
}

function EmailSubmission({ status, retry, exit }) {
  useEffect(() => {}, [status]);

  const SuccessView = () => {
    return (
      <>
        <DialogContent>
          <p>Successfully emailed form.</p>
        </DialogContent>
        <DialogActions>
          <button
            className="btn btn-success"
            onClick={() => {
              exit();
            }}
          >
            Close
          </button>
        </DialogActions>
      </>
    );
  };

  const FailureView = () => {
    return (
      <>
        <DialogContent>
          <p>Failed to email form. Would you like to try again?</p>
        </DialogContent>
        <DialogActions>
          <button
            className="btn btn-success"
            onClick={() => {
              retry();
            }}
          >
            Retry
          </button>
          <button
            className="btn btn-danger"
            onClick={() => {
              exit();
            }}
          >
            Cancel
          </button>
        </DialogActions>
      </>
    );
  };

  if (status == 'loading') {
    return (
      <>
        <DialogContent>
          <LoadingIndicator />
        </DialogContent>
        <DialogActions />
      </>
    );
  } else if (status == 'failure') {
    return <FailureView />;
  }
  return <SuccessView />;
}

export { EmailFormModal };
